import { Create, NumberInput, SimpleForm, TextInput } from "react-admin";

export function FaqCreate() {
  return (
    <Create>
      <SimpleForm>
        <TextInput source="question" fullWidth />
        <TextInput source="answer" fullWidth />
        <NumberInput source="serialNumber" min={1} defaultValue={1} />
      </SimpleForm>
    </Create>
  );
}
